import { gql } from "@apollo/client";

/** Interaction steps for one call plan; only fields needed for editor selection UI + activityIds on save. */
export const GET_CALL_PLAN_ACTIVITIES_QUERY = gql`
  query GetCallPlanActivities($callPlanId: Int!) {
    callPlan(id: $callPlanId) {
      id
      interactions {
        id
        order
        ... on ActivityInteraction {
          activityId
          title
          category
          difficulty
          activityTypes {
            activityTypeKey
            activityTypeLabel
          }
        }
      }
    }
  }
`;
